import { render, staticRenderFns } from "./TabImages.vue?vue&type=template&id=2699f65e&scoped=true&"
import script from "./TabImages.vue?vue&type=script&lang=ts&"
export * from "./TabImages.vue?vue&type=script&lang=ts&"
import style0 from "./TabImages.vue?vue&type=style&index=0&id=2699f65e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699f65e",
  null
  
)

export default component.exports